import React from 'react';
import { exerciseStructure, sampleMeta, sampleRows } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function LookInside() {
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-111" data-mp="21n0w6hjza3sc">
      <div className="mx-auto max-w-3xl" data-id="element-112" data-mp="21mhduzqf1dds">
        <Eyebrow data-id="element-113" data-mp="25ocfy6g67usm">Look inside</Eyebrow>
        <SectionTitle data-id="element-114" data-mp="25nks5hstf1cw">
          See how the exercises are <Mark data-id="element-115" data-mp="1rx7o3qj1o6su">organized inside the system</Mark>
        </SectionTitle>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-steel md:text-base" data-id="element-116" data-mp="1rvwjjohryv0o">
          Instead of showing only an exercise name, the material gives you practical information you can actually
          follow.
        </p>

        <article className="mt-8 overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-xl" data-id="element-117" data-mp="1mxlbnjb1iul3">
          <header className="bg-navy p-5" data-id="element-118" data-mp="18y3g8l38oj2r">
            <p className="text-[10px] font-extrabold uppercase tracking-wider text-brand-light" data-id="element-119" data-mp="18z52llppgrzs">Sample exercise</p>
            <h3 className="mt-1 font-display text-base font-black uppercase text-white md:text-lg" data-id="element-120" data-mp="1dz9cgsw3yoh1">
              Band External Rotation
            </h3>
          </header>
          <dl className="grid grid-cols-2 gap-px bg-navy/10 sm:grid-cols-4" data-id="element-121" data-mp="60jatrxhb4u8">
            {sampleMeta.map(([label, value]) => <div key={label} className="bg-white p-4" data-id="element-122" data-mp="jyhpkyfpp3a9">
                <dt className="text-[10px] font-extrabold uppercase tracking-wider text-steel" data-id="element-123" data-mp="f32doc19lhgh">{label}</dt>
                <dd className="mt-0.5 text-sm font-bold text-navy" data-id="element-124" data-mp="3ni3x1bmcon55">{value}</dd>
              </div>)}
          </dl>
          <div className="border-t border-navy/10 px-5 py-1" data-id="element-125" data-mp="3igmyhmrc9crq">
            <table className="w-full text-left text-sm" data-id="element-126" data-mp="12rl94kb3ut7">
              <tbody data-id="element-127" data-mp="3sgxc38hacm7f">
                {sampleRows.map(([label, value]) => <tr key={label} className="border-b border-navy/10 last:border-b-0" data-id="element-128" data-mp="3seubxvmf5coz">
                    <th scope="row" className="w-32 py-2.5 pr-3 align-top text-[10px] font-extrabold uppercase tracking-wider text-brand" data-id="element-129" data-mp="34p027mxec48y">
                      {label}
                    </th>
                    <td className="py-2.5 font-semibold text-navy" data-id="element-130" data-mp="18mwnshav4kja">{value}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          <div className="border-t border-navy/10 bg-canvas px-5 py-4" data-id="element-131" data-mp="1hg06b40d7nks">
            <p className="font-display text-[11px] font-black uppercase tracking-wider text-navy" data-id="element-132" data-mp="1hi2xvsh61orm">
              Every exercise can include:
            </p>
            <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-133" data-mp="ppvggptu68c6">
              {exerciseStructure.map(item => <li key={item} className="rounded-md border border-navy/10 bg-white px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-steel" data-id="element-134" data-mp="tp49fsh1y26o">
                  {item}
                </li>)}
            </ul>
          </div>
        </article>
      </div>
    </section>;
}